interface CategoryBadgeProps {
  category: string;
  size?: 'sm' | 'md';
}

const CATEGORY_STYLES: Record<string, string> = {
  行业内幕: 'bg-primary-100 text-primary-800 border-primary-200',
  消费乱象: 'bg-accent-100 text-accent-900 border-accent-300',
  维权纠纷: 'bg-secondary-100 text-secondary-900 border-secondary-200',
  争议事件: 'bg-foreground-100 text-foreground-800 border-foreground-200',
};

export default function CategoryBadge({ category, size = 'md' }: CategoryBadgeProps) {
  const style = CATEGORY_STYLES[category] ?? 'bg-secondary-100 text-secondary-900 border-secondary-200';
  const sizing = size === 'sm' ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs';

  return (
    <span
      className={`inline-flex items-center rounded-md border font-label font-medium tracking-wide whitespace-nowrap ${style} ${sizing}`}
    >
      {category}
    </span>
  );
}